var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPet = function SvgPet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94804 11.0344C9.0074 9.80185 11.3439 9.80184 12.4032 11.0344L16.1869 16.256C17.1085 17.3282 16.5421 18.6831 15.2394 19.2325C14.4348 19.5719 13.5525 19.2809 12.7657 18.8942C11.1747 18.1123 9.3569 18.1122 7.76601 18.8942C6.97929 19.2809 6.09722 19.5718 5.29269 19.2325C3.98996 18.6832 3.42355 17.3282 4.34513 16.256L7.94804 11.0344Z",
    stroke: "#282828",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5414 4.2619C10.7662 6.03705 9.91758 7.63475 8.64604 7.83047C7.3745 8.02618 6.16151 6.7458 5.93675 4.97065C5.71199 3.1955 6.56056 1.5978 7.8321 1.40208C9.10364 1.20637 10.3166 2.48675 10.5414 4.2619Z",
    stroke: "#282828",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48395 8.03679C5.37457 9.14728 5.42698 10.7003 4.60102 11.5056C3.77506 12.3109 2.3835 12.0634 1.49288 10.9529C0.602265 9.84244 0.549852 8.2894 1.37581 7.48413C2.20178 6.67886 3.59334 6.9263 4.48395 8.03679Z",
    stroke: "#282828",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0421 3.26653C18.1366 4.06413 18.281 5.94973 17.3648 7.47813C16.4486 9.00653 14.8186 9.59896 13.7241 8.80136C12.6296 8.00376 12.4851 6.11817 13.4013 4.58976C14.3176 3.06136 15.9476 2.46893 17.0421 3.26653Z",
    stroke: "#282828",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1783 9.95426C22.0105 10.6823 21.9896 12.2391 21.1316 13.4313C20.2736 14.6235 18.9034 14.9998 18.0712 14.2717C17.2389 13.5436 17.2598 11.9869 18.1179 10.7947C18.9759 9.60245 20.3461 9.22617 21.1783 9.95426Z",
    stroke: "#282828",
    strokeWidth: 1.5
  })));
};
export default SvgPet;